var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions-wrapper"},[_vm._l((_vm.questionTypes),function(item){return _c('div',{key:item.id,staticClass:"question-item",class:{
      disabled: _vm.blackFlag!=0 || _vm.isQueue
    },on:{"click":function($event){return _vm.selectQuestion('service', item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),_c('div',{staticClass:"question-item full-width person",class:{
      disabled: _vm.blackFlag!=0 || _vm.isQueue
    },on:{"click":function($event){return _vm.selectQuestion('personService', 0)}}},[_vm._v(" 人工客服 ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }